import { Component } from "@angular/core";
import { PanelIconPhoneComponent } from "./panel-icon-phone/panel-icon-phone.component";
import { PanelIconCellphoneComponent } from "./panel-icon-cellphone/panel-icon-cellphone.component";
import { PanelIconClientCodeComponent } from "./panel-icon-client-code/panel-icon-client-code.component";
import { PanelIconEmailComponent } from "./panel-icon-email/panel-icon-email.component";
import { PanelIconUsersComponent } from "./panel-icon-users/panel-icon-users.component";
import { PanelIcon } from "./panel-icon.class";

@Component({
    selector: "wk-panel-icons",
    imports: [PanelIconPhoneComponent, PanelIconCellphoneComponent, PanelIconUsersComponent, PanelIconClientCodeComponent, PanelIconEmailComponent],
    templateUrl: "./panel-icons.component.html",
    styleUrl: "./panel-icons.component.scss",
})
export class PanelIconsComponent extends PanelIcon {}
